import type { MouseEventHandler } from 'react';
import { useCallback } from 'react';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import type { ButtonSize } from 'components/Button/Button.types';
import { AnimatedCheckmark } from 'components/Icon/AnimatedCheckmark';
import { useI18n } from 'i18n/hooks/useI18n';
import { scrollIntoView } from 'utils/scrollIntoView';

type Props = {
  atsIsEnabled: boolean;
  size?: ButtonSize;
  className?: string;
  tabIndex?: number;
  applied: boolean;
};

export function ScrollToApplyButton({
  atsIsEnabled,
  size,
  className,
  tabIndex,
  applied,
}: Props) {
  const { i18n } = useI18n();

  const onClick: MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
    const element = document.getElementById('apply');

    if (element) {
      e.preventDefault();
      scrollIntoView(element, {
        highlight: true,
      });
    }
  }, []);

  if (atsIsEnabled && applied) {
    return (
      <Button
        type="button"
        data-qa-id="easy-apply-button"
        disabled
        variant="primary"
        size={size ?? 'large'}
        tabIndex={tabIndex}
      >
        <Box display="flex" alignItems="center" className={className}>
          <Box display="flex" mr="8px">
            <AnimatedCheckmark colorName="brandGreen" size={16} />
          </Box>
          {i18n('Applied')}
        </Box>
      </Button>
    );
  }

  return (
    <Button
      type="link"
      data-qa-id="easy-apply-button"
      href="#apply"
      variant="primary"
      onClick={onClick}
      className={className}
      size={size ?? 'large'}
      tabIndex={tabIndex}
    >
      {i18n('Apply')}
    </Button>
  );
}
